var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p-blockui',{class:_vm.blocked? 'loader_bg':'',attrs:{"blocked":_vm.blocked}},[_c('div',{staticClass:"blockui-content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }